import { createApp } from 'vue';
import AacToMp3Converter from '@/Components/AacToMp3Converter.vue';
import '@styles/app.css';

createApp(AacToMp3Converter).mount('#aac-to-mp3-converter');
